import { render, staticRenderFns } from "./BaseBeam.vue?vue&type=template&id=a7d0bb5e&scoped=true&"
import script from "./BaseBeam.vue?vue&type=script&lang=js&"
export * from "./BaseBeam.vue?vue&type=script&lang=js&"
import style0 from "./BaseBeam.vue?vue&type=style&index=0&id=a7d0bb5e&scoped=true&lang=scss&"
import style1 from "./BaseBeam.vue?vue&type=style&index=1&id=a7d0bb5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d0bb5e",
  null
  
)

export default component.exports